import { RpcError } from 'grpc-web';
import { HasPaymentMethodResponse, ShareAnalytics } from '../../../proto/api_pb';
import { TrackVersion } from '../../../proto/api_pb';
import { fetchTrackVersions } from '../../../services/trackService';
import { getHasPaymentMethod } from '../../../services/stripeService';
import { awaitableUploadToS3 } from '../../../utils/S3Utils';
import { toast } from 'react-toastify';
import { getNextVersionNumber } from '../../../pages/MyTracks/utils';
import { AddShareAnalyticsEvent } from '../../../services/shareService';

const ASSETS_URL = process.env.REACT_APP_ASSET_S3_BUCKET_URL!;

export const downloadSong = async (
  trackUrl: string,
  title: string | undefined,
  shareId: string,
  userName: string,
  token: string
): Promise<void> => {
  try {
    const sh = new ShareAnalytics();
    sh.setShareId(shareId);
    sh.setType('DOWNLOAD');
    const response = await fetch('https://ipapi.co/json/');
    if (response.ok) {
      const data = await response.json();
      sh.setIp(data.ip);
      sh.setCountry(data.country_name);
    }
    sh.setTimestamp(Date.now());
    sh.setOmmuseUsername(userName);
    const res = await AddShareAnalyticsEvent(token, sh);
    if (res instanceof RpcError) toast.warn('Failed to update analytics event');
    const link = document.createElement('a');
    link.href = trackUrl;
    link.download = title!;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {}
};

export const handleFetchTrackVersions = async (
  token: string,
  id: string
): Promise<
  | {
      track: TrackVersion;
      isPlaying: boolean;
    }[]
  | undefined
> => {
  try {
    const response = await fetchTrackVersions(token, id!);
    if (!response) return undefined;
    if (response instanceof RpcError) return undefined;
    const newTrackVersionList = response.getTrackVersionsList().map((el) => {
      return { track: el, isPlaying: false };
    });
    return newTrackVersionList;
  } catch (e) {
    const error = e as RpcError;
  }
};

export const handleGetNextVersionNumber = async (token: string, id: string): Promise<number> => {
  try {
    const response = await fetchTrackVersions(token, id!);
    if (!response) return 0;
    if (response instanceof RpcError) return 0;
    const newTrackVersionList = response.getTrackVersionsList();
    newTrackVersionList.sort((a, b) => b.getVersionNumber() - a.getVersionNumber());
    const nextVersionNumList = getNextVersionNumber(
      newTrackVersionList[0].getVersionNumber(),
      true
    );

    return parseFloat(nextVersionNumList[0]);
  } catch (e) {
    const error = e as RpcError;
    return 0;
  }
};

export const getPaymentMethod = async (
  token: string,
  userId: string
): Promise<HasPaymentMethodResponse | undefined> => {
  try {
    const response = (await getHasPaymentMethod(token, userId!)) as HasPaymentMethodResponse;
    return response;
  } catch (e) {
    const error = e as RpcError;
  }
};

export const onDownload = async (
  file: File,
  awsAccessKeyId: string | undefined,
  awsSecretAccessKey: string | undefined,
  awsSessionToken: string | undefined,
  userId: string
): Promise<string> => {
  const uploadedKey = await awaitableUploadToS3(
    userId,
    file,
    `song`,
    file.type,
    awsAccessKeyId,
    awsSecretAccessKey,
    awsSessionToken,
    () => {}
  );
  return ASSETS_URL + '/' + uploadedKey;
};
